/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SearchSubRuleBulkUpdateData,
    SearchSubRuleBulkUpdateDataFromJSON,
    SearchSubRuleBulkUpdateDataToJSON,
    SearchSubRuleBulkUpdateFormValidationData,
    SearchSubRuleBulkUpdateFormValidationDataFromJSON,
    SearchSubRuleBulkUpdateFormValidationDataToJSON,
    SearchSubRuleFormConfiguration,
    SearchSubRuleFormConfigurationFromJSON,
    SearchSubRuleFormConfigurationToJSON,
    SearchSubRuleFormData,
    SearchSubRuleFormDataFromJSON,
    SearchSubRuleFormDataToJSON,
    SearchSubRuleFormValidationData,
    SearchSubRuleFormValidationDataFromJSON,
    SearchSubRuleFormValidationDataToJSON,
    SearchSubRuleFormWarningsData,
    SearchSubRuleFormWarningsDataFromJSON,
    SearchSubRuleFormWarningsDataToJSON,
    SearchSubRuleListItem,
    SearchSubRuleListItemFromJSON,
    SearchSubRuleListItemToJSON,
    SearchSubRuleStateResponse,
    SearchSubRuleStateResponseFromJSON,
    SearchSubRuleStateResponseToJSON,
} from '../models';

export interface ApiSearchSubRuleSearchSubRuleFormBulkUpdatePostRequest {
    searchSubRuleBulkUpdateData?: SearchSubRuleBulkUpdateData;
}

export interface ApiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePostRequest {
    searchSubRuleBulkUpdateData?: SearchSubRuleBulkUpdateData;
}

export interface ApiSearchSubRuleSearchSubRuleFormConfigurationGetRequest {
    supplier?: string;
}

export interface ApiSearchSubRuleSearchSubRuleFormCreatePostRequest {
    searchSubRuleFormData?: SearchSubRuleFormData;
}

export interface ApiSearchSubRuleSearchSubRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiSearchSubRuleSearchSubRuleFormUpdatePostRequest {
    searchSubRuleFormData?: SearchSubRuleFormData;
}

export interface ApiSearchSubRuleSearchSubRuleFormValidatePostRequest {
    searchSubRuleFormData?: SearchSubRuleFormData;
}

export interface ApiSearchSubRuleSearchSubRuleFormWarningsPostRequest {
    searchSubRuleFormData?: SearchSubRuleFormData;
}

/**
 * no description
 */
export class SearchSubRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormBulkUpdatePostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormBulkUpdatePostRequest): Promise<runtime.ApiResponse<Array<SearchSubRuleStateResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/BulkUpdate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleBulkUpdateDataToJSON(requestParameters.searchSubRuleBulkUpdateData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SearchSubRuleStateResponseFromJSON));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormBulkUpdatePost(requestParameters: ApiSearchSubRuleSearchSubRuleFormBulkUpdatePostRequest): Promise<Array<SearchSubRuleStateResponse>> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormBulkUpdatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePostRequest): Promise<runtime.ApiResponse<SearchSubRuleBulkUpdateFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/BulkUpdateValidate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleBulkUpdateDataToJSON(requestParameters.searchSubRuleBulkUpdateData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleBulkUpdateFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePost(requestParameters: ApiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePostRequest): Promise<SearchSubRuleBulkUpdateFormValidationData> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormBulkUpdateValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormConfigurationGetRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormConfigurationGetRequest): Promise<runtime.ApiResponse<SearchSubRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.supplier !== undefined) {
            queryParameters['supplier'] = requestParameters.supplier;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormConfigurationGet(requestParameters: ApiSearchSubRuleSearchSubRuleFormConfigurationGetRequest): Promise<SearchSubRuleFormConfiguration> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormCreatePostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormCreatePostRequest): Promise<runtime.ApiResponse<SearchSubRuleListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleFormDataToJSON(requestParameters.searchSubRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormCreatePost(requestParameters: ApiSearchSubRuleSearchSubRuleFormCreatePostRequest): Promise<SearchSubRuleListItem> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormGetByIdGetRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<SearchSubRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormGetByIdGet(requestParameters: ApiSearchSubRuleSearchSubRuleFormGetByIdGetRequest): Promise<SearchSubRuleFormData> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormUpdatePostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<SearchSubRuleListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleFormDataToJSON(requestParameters.searchSubRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormUpdatePost(requestParameters: ApiSearchSubRuleSearchSubRuleFormUpdatePostRequest): Promise<SearchSubRuleListItem> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormUpdatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormValidatePostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormValidatePostRequest): Promise<runtime.ApiResponse<SearchSubRuleFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleFormDataToJSON(requestParameters.searchSubRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormValidatePost(requestParameters: ApiSearchSubRuleSearchSubRuleFormValidatePostRequest): Promise<SearchSubRuleFormValidationData> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormWarningsPostRaw(requestParameters: ApiSearchSubRuleSearchSubRuleFormWarningsPostRequest): Promise<runtime.ApiResponse<SearchSubRuleFormWarningsData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/SearchSubRule/SearchSubRuleForm/Warnings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchSubRuleFormDataToJSON(requestParameters.searchSubRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSubRuleFormWarningsDataFromJSON(jsonValue));
    }

    /**
     */
    async apiSearchSubRuleSearchSubRuleFormWarningsPost(requestParameters: ApiSearchSubRuleSearchSubRuleFormWarningsPostRequest): Promise<SearchSubRuleFormWarningsData> {
        const response = await this.apiSearchSubRuleSearchSubRuleFormWarningsPostRaw(requestParameters);
        return await response.value();
    }

}
